function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.333 6.527a2 2 0 00-2 2v18.14a1.333 1.333 0 01-2.666 0V6a2 2 0 012-2h4.736a1.263 1.263 0 010 2.527h-2.07z",
  fill: "#4462FF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.57 2.996l10.667 1.933a1.333 1.333 0 011.096 1.312v19.517a1.333 1.333 0 01-1.096 1.312l-10.666 1.934A1.334 1.334 0 0112 27.692V4.306a1.333 1.333 0 011.57-1.312v.002zm2.32 14.212c.92 0 1.666-.81 1.666-1.812 0-1-.747-1.812-1.667-1.812s-1.666.81-1.666 1.812c0 1 .746 1.812 1.666 1.812z",
  fill: "#4462FF"
}));